import React from 'react';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import AgencyCoApp from './reducers';
import createSagaMiddleware from 'redux-saga';
import Routes from './routers';
import mySaga from './sagas/subscribe';
import { seedAllPosts, upsertPost, getPostsByCategory } from './services/postService';
import { SEED_POSTS } from './data/seedContent';

const COVER_IMAGE_PATCHES = [
  { slug: 'how-to-waterproof-hiking-boots',              coverImage: '/img/how-to-waterproof-hiking-boots.webp' },
  { slug: 'desert-hiking-tips',                          coverImage: '/img/desert-hiking-tips.webp' },
  { slug: 'how-to-identify-poisonous-plants',            coverImage: '/img/how-to-identify-poisonous-plants.webp' },
  { slug: 'how-to-navigate-without-gps',                 coverImage: '/img/how-to-navigate-without-gps.webp' },
  { slug: 'how-to-prevent-dehydration-hiking',           coverImage: '/img/how-to-prevent-dehydration-hiking.webp' },
  { slug: 'hypothermia-prevention-hiking',               coverImage: '/img/hypothermia-prevention-hiking.webp' },
  { slug: 'lake-serene-trail-guide',                     coverImage: '/img/lake-serene-trail-guide.webp' },
  { slug: 'leave-no-trace-principles',                   coverImage: '/img/leave-no-trace-principles.webp' },
  { slug: 'lightning-safety-for-hikers',                 coverImage: '/img/lightning-safety-for-hikers.webp' },
  { slug: 'night-hiking-tips',                           coverImage: '/img/night-hiking-tips.webp' },
  { slug: 'overnight-backpacking-checklist',             coverImage: '/img/overnight-backpacking-gear-list.webp' },
  { slug: 'what-to-do-if-you-get-lost-hiking',           coverImage: '/img/what-to-do-if-lost-hiking.webp' },
  { slug: 'what-to-eat-before-a-long-hike',              coverImage: '/img/what-to-eat-before-hiking.webp' },
  { slug: 'what-to-wear-hiking-beginners',               coverImage: '/img/what-to-wear-hiking.webp' },
  { slug: 'how-much-water-to-drink-hiking',              coverImage: '/img/how-much-water-to-drink-hiking.webp' },
  { slug: 'how-to-build-hiking-endurance',               coverImage: '/img/how-to-build-hiking-endurance.webp' },
  { slug: 'how-to-hike-in-extreme-heat',                 coverImage: '/img/how-to-hike-in-extreme-heat.webp' },
  { slug: 'how-to-hike-in-snow-and-ice',                 coverImage: '/img/how-to-hike-in-snow-and-ice-alt.webp' },
  { slug: 'how-to-hike-in-the-rain',                     coverImage: '/img/how-to-hike-in-the-rain.webp' },
  { slug: 'how-to-hike-with-kids',                       coverImage: '/img/how-to-hike-with-kids.webp' },
  { slug: 'how-to-protect-yourself-from-wildlife-while-hiking', coverImage: '/img/how-to-protect-yourself-from-wildlife-while-hiking.webp' },
  { slug: 'how-to-read-a-topographic-map',               coverImage: '/img/how-to-read-a-topographic-map.webp' },
  { slug: 'how-to-use-hiking-poles-correctly',           coverImage: '/img/how-to-use-hiking-poles-correctly.webp' },
  { slug: 'mount-si-hiking-guide',                       coverImage: '/img/mount-si-hiking-guide.webp' },
  { slug: 'rattlesnake-ledge-trail-guide',               coverImage: '/img/rattlesnake-ledge-trail-guide.webp' },
  { slug: 'sun-protection-for-hikers',                   coverImage: '/img/sun-protection-for-hikers.webp' },
  { slug: 'enchantments-hiking-guide',                   coverImage: '/img/enchantments-hiking-guide.webp' },
  { slug: 'zion-narrows-hiking-guide',                   coverImage: '/img/zion-narrows-hiking-guide.webp' },
  { slug: 'hiking-first-aid-kit-essentials',             coverImage: '/img/hiking-first-aid-kit-essentials-alt.webp' },
];

const sagaMiddleware = createSagaMiddleware();

const store = createStore(
  AgencyCoApp,
  composeWithDevTools(applyMiddleware(sagaMiddleware))
);

sagaMiddleware.run(mySaga);

if (process.env.NODE_ENV === 'development') {
  window.seedExplorOFF = () =>
    seedAllPosts(SEED_POSTS)
      .then(() => console.log('✅ All posts seeded to Firestore'))
      .catch(err => console.error('❌ Seed failed:', err));

  window.patchCoverImages = async () => {
    let ok = 0, fail = 0;
    for (const { slug, coverImage } of COVER_IMAGE_PATCHES) {
      try {
        await upsertPost(slug, { coverImage });
        console.log(`✅ ${slug}`);
        ok++;
      } catch (e) {
        console.error(`❌ ${slug}:`, e.message);
        fail++;
      }
    }
    console.log(`Done: ${ok} updated, ${fail} failed`);
  };

  window.listMissingImages = () =>
    getPostsByCategory('hiking-guides')
      .then(posts => {
        const missing = posts.filter(p => !p.coverImage).map(p => p.id);
        if (missing.length === 0) {
          console.log('✅ All hiking-guides posts have a coverImage');
        } else {
          console.log(`❌ ${missing.length} posts missing coverImage:\n` + missing.join('\n'));
        }
        return missing;
      });
}

function App() {
  return (
    <Provider store={store}>
      <Routes />
    </Provider>
  );
}

export default App;
